import React, { useState } from "react";
import { Sparkles, ArrowRight } from "lucide-react";
import TrainingInquiryModal from "./TrainingInquiryModal";

const TRACK_LABELS = { data_cloud: "Data Cloud", sfmc: "SFMC", mc_next: "MC Next" };
const TRACK_BORDER = { data_cloud: "border-indigo-400/30", sfmc: "border-teal-400/30", mc_next: "border-fuchsia-400/30" };
const TRACK_TEXT = { data_cloud: "text-indigo-400", sfmc: "text-teal-400", mc_next: "text-fuchsia-400" };
const TRACK_BTN = {
  data_cloud: "bg-indigo-500 hover:bg-indigo-600",
  sfmc: "bg-teal-500 hover:bg-teal-600",
  mc_next: "bg-fuchsia-500 hover:bg-fuchsia-600",
};

export default function TrainingInquiryBanner({ track = "data_cloud" }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className={`glass-panel rounded-2xl p-4 sm:p-5 mb-6 flex items-center justify-between flex-wrap gap-3 border ${TRACK_BORDER[track]}`}
        data-testid={`training-inquiry-banner-${track}`}
      >
        <div className="flex items-center gap-3">
          <div className={`w-9 h-9 rounded-full border ${TRACK_BORDER[track]} flex items-center justify-center shrink-0`}>
            <Sparkles className={`w-4 h-4 ${TRACK_TEXT[track]}`} />
          </div>
          <div>
            <p className="text-sm font-semibold text-white">Want to master {TRACK_LABELS[track]} faster?</p>
            <p className="text-xs text-slate-400">Talk to our advisor on WhatsApp or request a callback for the paid mentorship program.</p>
          </div>
        </div>
        <button
          onClick={() => setOpen(true)}
          data-testid={`training-inquiry-banner-cta-${track}`}
          className={`flex items-center gap-1.5 text-white text-xs font-semibold px-4 py-2.5 rounded-lg transition-colors shrink-0 ${TRACK_BTN[track]}`}
        >
          Get Guidance <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
      <TrainingInquiryModal open={open} onClose={() => setOpen(false)} defaultTrack={track} />
    </>
  );
}
